// @flow

class Email {
  static isValid(email: string): boolean {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
  }
}


export default Email;



// WEBPACK FOOTER //
// ./src/statsradio/domain/Email.js